
export interface Config {
  withCredentials?: boolean
  otherCookies?: string
  timeout?: number
  headers?: { [key: string]: any }
}

export abstract class AbstractRequest {
  abstract request(url: string, data: any, method: string);
  abstract post(url: string, params: { [key: string]: any }, config: Config);
  abstract get(url: string, data: any, config: Config);
  abstract cancelAllRequest();
  abstract cancelAllRequestFromUrl(url: string);
}


